import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=61a823f6&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"
import style0 from "./TreeChart.vue?vue&type=style&index=0&id=61a823f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a823f6",
  null
  
)

export default component.exports